import * as z from "zod";

/**
 * Resolves the list of ConciergeKnowledge articles that fed a particular
 * AI-generated message (or draft). The lookup path depends on which support
 * stack produced the message:
 *
 *   - `v1_message`: legacy support stack. The conversation's
 *     `aiInformation.auditLog` is keyed by the inbound (customer) message id
 *     that triggered the AI response, so callers pass the conversation id and
 *     that customer message id.
 *   - `v2_draft`: support-v2 stack. `ai_knowledge_use` rows are written at
 *     agent-execution time linked to the produced draft.
 *   - `v2_message`: support-v2 stack. After a draft is promoted to a sent
 *     message, `ai_knowledge_use` rows are re-linked to the message id.
 */
export const getKnowledgeSourcesForMessage = {
  name: "getKnowledgeSourcesForMessage" as const,
  input: z.discriminatedUnion("kind", [
    z.object({
      kind: z.literal("v1_message"),
      conversationId: z.string(),
      customerMessageId: z.string(),
    }),
    z.object({ kind: z.literal("v2_draft"), draftMessageId: z.string() }),
    z.object({ kind: z.literal("v2_message"), messageId: z.string() }),
  ]),
  output: z.object({
    sources: z.array(z.object({ id: z.string(), title: z.string() })),
  }),
};
